/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { DateTime } from 'luxon'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Badge, BadgeProps } from '@mantine/core'

export type LeaseStatusBadgeProps = BadgeProps & {
  lease: Lease
}

function LeaseStatusBadge (props: LeaseStatusBadgeProps) {
  const { lease, ...others } = props
  const startedDate = useMemo(() => DateTime.fromISO(lease.startDate), [lease])
  const endDate = useMemo(() => DateTime.fromISO(lease.endDate), [lease])
  const hasEnded = useMemo(() => endDate && endDate <= DateTime.now(), [endDate])
  const hasStarted = useMemo(() => startedDate <= DateTime.now(), [startedDate])
  const endsSoon = useMemo(() => (
    !hasEnded &&
    lease.noticeDate &&
    DateTime.fromISO(lease.noticeDate) <= DateTime.now()
  ), [hasEnded, lease.noticeDate])

  let color

  if (hasEnded) {
    color = 'gray'
  } else if (endsSoon) {
    color = 'yellow'
  } else if (hasStarted) {
    color = 'green'
  } else {
    color = 'blue'
  }

  return (
    <Badge {...others} color={color}>
      {!hasStarted
        ? <FormattedMessage
          id="to_come_up"
          defaultMessage="À venir"
        />
        : null}

      {hasStarted && !hasEnded
        ? <>
          {endsSoon
            ? <FormattedMessage
              id="notice"
              defaultMessage="Préavis"
            />
            : <FormattedMessage
              id="ongoing"
              defaultMessage="En cours"
            />
          }
        </>
        : null}

      {hasEnded
        ? <FormattedMessage
          id="finished"
          defaultMessage="Terminé"
        />
        : null}
    </Badge>
  )
}

export default LeaseStatusBadge
